// Pathify
import Vue from 'vue'
import { make } from 'vuex-pathify'
import axios from 'axios'
import router from '@/router'
import store from '@/store'

Vue.use(router)

// Data
const state = {
  datas: JSON.parse(localStorage.getItem('cumuluslog@datasource')) || {
    airports: null,
    operators: null,
    users: null,
    planeTypes: null,
    roles: null,
    permissions: null,
    documentTypes: null,
    airportCountries: null,
  },
}

const mutations = {
  ...make.mutations(state),
}

const actions = {
  ...make.actions(state),
  init: async ({ dispatch }) => {
  },
  clear () {
    state.datas = {}
    localStorage.removeItem('cumuluslog@datasource')
    console.log('Datasource Clear Success')
  },
  fetchDatasource (context, payload) {
    return new Promise((resolve, reject) => {
      if (state.datas[payload.sourceType] != null && payload.sourceType !== 'planes') {
        return resolve(state.datas[payload.sourceType])
      }
      axios.get('/api/datasource/' + payload.sourceType)
        .then(result => {
          state.datas[payload.sourceType] = result.data
          localStorage.setItem('cumuluslog@datasource', JSON.stringify(state.datas))
          resolve(result.data)
        }).catch(error => {
          console.log(error)
          reject(error)
      })
    })
  },
  fetchGraph (context, payload) {
    return new Promise((resolve, reject) => {
      if (payload.graph_name === 'flightStat/glider') {
        // console.log(store.get('auth/profile@flight_stat_glider'))
        return resolve(store.get('auth/profile').flight_stat_glider)
      } else if (payload.graph_name === 'flightStat/general') {
        return resolve(store.get('auth/profile').flight_stat_general)
      }
      /* let param = ''
      if (payload.id) {
        param += '/' + payload.id
      }
      axios.get('/api/graphs/' + payload.graph_name + param)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        reject(error)
      }) */
    })
  },
  globalSearch (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/datasource/global-search', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        reject(error)
      })
    })
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
